import { Injectable } from '@angular/core';
import { ValidationProblemDetails } from '../../models/error-responses/validation-problem-details.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ValidationError } from '../../models/error-responses/validation-error.model';
import { ErrorResponseHandler } from './error-response-handler';

@Injectable()
export class ValidationErrorResponseHandler implements ErrorResponseHandler {
  priority = 100;

  canHandle(error: HttpErrorResponse): boolean {
    if (error.status === 400 && this.isValidationProblemDetails(error.error)) {
      return true;
    }

    return false;
  }

  isValidationProblemDetails(problem: unknown): problem is ValidationProblemDetails {
    if (!problem || typeof problem !== 'object') {
      return false;
    }

    if (!('errors' in problem)) {
      return false;
    }

    const { errors } = problem as { errors?: unknown };
    return (
      errors === null ||
      errors === undefined ||
      (typeof errors === 'object' && errors !== null && !Array.isArray(errors))
    );
  }

  buildErrorMessages(error: HttpErrorResponse): string[] {
    const messages: string[] = [];
    const problem: ValidationProblemDetails = error.error as ValidationProblemDetails;
    const errors: Record<string, ValidationError> | undefined = problem.errors;

    if (errors) {
      for (const [field, fieldErrors] of Object.entries(errors)) {
        for (const message of fieldErrors) {
          messages.push(`${field}: ${message}`);
        }
      }
    }

    if (messages.length === 0) {
      return ['Validation failed.'];
    }

    return messages;
  }

  defaultErrorMessage(): string {
    return 'Validation issue.';
  }
}
